namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.maximizable()
    @Serenity.Decorators.resizable()
    export class ApiScriptOperazioniDialog extends Serenity.PropertyDialog<any, any> {
        protected getFormKey() { return ApiScriptOperazioniForm.formKey; }

        protected form = new ApiScriptOperazioniForm(this.idPrefix);

        constructor() {
            super();
        }

        /**
         * Here we override loadInitialEntity method to set value for "DisplayFieldValue" field.
         * If this was an EntityDialog, your field value would be originating from server side entity.
         */
        protected loadInitialEntity() {
            this.propertyGrid.load({
                VisualizzaApi: ''
            });
        }

        protected getDialogOptions() {
            var opt = super.getDialogOptions();
            opt.title = "API Script operazioni";
            opt.width = 1000;
            return opt;
        }

        protected getDialogButtons() {
            var buttons = super.getDialogButtons();

            // Add button
            buttons.unshift({
                text: 'Esporta',
                click: () => { /*Add Function Here */

                    var nIdProdotto = +(this.form.IdProdotto.value);
                    var nIdApi = +(this.form.IdApi.value);

                    if (nIdProdotto == 0) {
                        Q.notifyWarning("Selezionare il prodotto da utilizzare.")
                    }

                    if (nIdApi == 0) {
                        Q.notifyWarning("Selezionare l'API da utilizzare.")
                    }

                    if (getIsSelectedTabByEditor(this.form.IdProdottoBadge)) {

                        var nIdProdottoBadge = +(this.form.IdProdottoBadge.value);

                        if (nIdProdottoBadge == 0) {
                            Q.notifyWarning("Selezionare il badge da utilizzare.")
                        }

                        Gamification.ProdottiBadgeService.Retrieve({
                            EntityId: nIdProdottoBadge
                        }, response => {
                            if (true) {
                                Q.notifySuccess(response.Entity.Nome);

                                var theDialog = new ApiScriptCodiceDialog();
                                theDialog.Codice = "Codice da inserire.";
                                theDialog.dialogOpen(false);
                            }
                        });
                    }

                    if (getIsSelectedTabByEditor(this.form.IdProdottoEsperienza)) {

                        var nIdProdottoEsperienza = +(this.form.IdProdottoEsperienza.value);

                        if (nIdProdottoEsperienza == 0) {
                            Q.notifyWarning("Selezionare l'esperienza da utilizzare.")
                        }

                        Gamification.ProdottiEsperienzeService.Retrieve({
                            EntityId: nIdProdottoEsperienza
                        }, response => {
                            if (true) {
                                Q.notifySuccess(response.Entity.Nome);

                                var theDialog = new ApiScriptCodiceDialog();
                                theDialog.Codice = "Codice da inserire.";
                                theDialog.dialogOpen(false);
                            }
                        });

                    }

                    if (getIsSelectedTabByEditor(this.form.IdProdottoEsperienzaTask)) {

                        var nIdProdottoEsperienzaTask = +(this.form.IdProdottoEsperienzaTask.value);

                        if (nIdProdottoEsperienzaTask == 0) {
                            Q.notifyWarning("Selezionare il task da utilizzare.")
                        }

                        Gamification.ProdottiEsperienzeTaskService.Retrieve({
                            EntityId: nIdProdottoEsperienzaTask
                        }, response => {
                            if (true) {
                                Q.notifySuccess(response.Entity.Nome);

                                var theDialog = new ApiScriptCodiceDialog();
                                theDialog.Codice = "Codice da inserire.";
                                theDialog.dialogOpen(false);
                            }
                        });
                    }

                }
            });

            // Remove button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "btn-primary"), 1);

            return buttons;
        }
    }
}